export default __webpack_public_path__ + "static/media/netmeds.8a5bb547.png";